import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import connectUI from 'redux-ui';
import { CUT_POINT, EMPLOYEE_ROLES } from 'config/constants';
import RouterLink from 'components/RouterLink';
import { IconButton } from 'react-toolbox';
import FlexBox from 'flexbox-react';
import MediaQuery from 'react-responsive';
import { ResourceDetailsCardElement } from 'components/ResourceCardElements';
import { ThemeProvider } from 'react-css-themr';
import { can } from '../../../../services';
import { userResendLink } from 'actionCreators';
import styles from './styles.scss';
import headerStyles from './headerResourceDetailsCard.scss';
import { stringifyList, roleNotInstallerBased } from '../../../../utils';
import UserType from 'types/user';
import WorkroomType from 'types/workroom';

const headerResourceDetails = { ResourceDetailsCE: headerStyles };

class UserDetailsHeader extends Component {
  componentWillUnmount = () => (this.props.ui.successMessage ? this.props.updateUI('successMessage', '') : null);

  getWorkroomsString = (workrooms, userWorkrooms) => {
    if (workrooms.length && this.isObjectArray(workrooms)) return stringifyList(workrooms);
    if (typeof userWorkrooms === 'string') return userWorkrooms;
    return (userWorkrooms.length && this.isObjectArray(userWorkrooms)) ? stringifyList(userWorkrooms) : '';
  }

  isObjectArray = (arr = []) => arr.every(i => typeof i === 'object');

  resendLink = (e) => {
    if (e) e.preventDefault();
    this.props.userResendLink(this.props.user.user_id).then(this.props.updateUI('successMessage',
      'The confirmation email was resent. This email will expire in 7 days.'));
  }

  renderEditHandler = (view = 'large') => {
    if (this.props.editHandler) return this.props.editHandler;
    const { user, type } = this.props;
    const endpoint = `/${type}/${user.id}/edit`;
    return (view === 'large') ? (<RouterLink className={styles.userDetailsButton}to={endpoint}>
      Edit
    </RouterLink>) : (<RouterLink to={endpoint}>
      <IconButton className={styles.userDetailsEdit} icon="edit" />
    </RouterLink>);
  }

  renderRightComponent = () => {
    const { user, role, resource, editHandler, editAction } = this.props;
    if (!editHandler && !can(role, editAction, resource)) return null;
    return (<FlexBox alignItems="center">
      <MediaQuery minWidth={CUT_POINT} style={{ display: 'flex' }}>
        {(user.pending && can(role, 'resend', resource)) ? <FlexBox>
          <button className={styles.userDetailsLink} onClick={this.resendLink}>
            Resend activation email
          </button>
          <div className={styles.userDetailsLinkSeparator} />
        </FlexBox> : null}
        <FlexBox>{this.renderEditHandler()}</FlexBox>
      </MediaQuery>
      <MediaQuery maxWidth={CUT_POINT - 1}>
        <FlexBox>{this.renderEditHandler('small')}</FlexBox>
      </MediaQuery>
    </FlexBox>);
  }

  render = () => {
    const { children, workrooms = [], role, user: {
      active, workrooms: userWorkrooms = [],
      type, name, assignable, position = '', id, user: userRole,
    } } = this.props;
    const statusText = active ? 'Active' : 'Inactive';
    let roleName = null;
    if (userRole) {
      const roleObj = EMPLOYEE_ROLES.find(r => r.value === userRole);
      roleName = roleObj ? roleObj.label : userRole;
    }
    const workroomsString = this.getWorkroomsString(workrooms, userWorkrooms);
    return (<FlexBox justifyContent="space-between" className={styles.userDetailsDivider}>
      <ThemeProvider theme={headerResourceDetails}>
        <FlexBox>
          <ResourceDetailsCardElement>
            <h2 className={styles.userDetailsName}>
              {roleNotInstallerBased(role) && (type === 'installer' || type === 'estimator') ? (
                <span className={styles.nameOnly}>{name} ({id})</span>
              ) : (<span className={styles.nameOnly}>{name}</span>)}
              {roleName && roleNotInstallerBased(role) && <span className={styles.userRole}>{` (${roleName})`}</span>}
              {' '}{roleNotInstallerBased(role) && <span className={active ? styles.activeText : styles.inactiveText}>
                {type === 'installer' || type === 'estimator' ? statusText : `(${statusText})`}
              </span>}
              {assignable && roleNotInstallerBased(role) &&
                <span className={styles.activeText}> (Assignable)</span>}
            </h2>
            {roleNotInstallerBased(role) && <h3 className={styles.userDetailsPosition}>
              {`${position}${workroomsString.length ? ' in ' : ''}${workroomsString}`}
            </h3>}
          </ResourceDetailsCardElement>
        </FlexBox>
      </ThemeProvider>
      {children}
      {this.renderRightComponent()}
    </FlexBox>);
  }
}

UserDetailsHeader.defaultProps = {
  workrooms: [],
  userResendLink: () => {},
  children: null,
  updateUI: () => {},
  ui: {},
  editHandler: null,
  editAction: 'update',
};

UserDetailsHeader.propTypes = {
  user: UserType.isRequired,
  workrooms: PropTypes.arrayOf(WorkroomType),
  role: PropTypes.string.isRequired,
  editAction: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  resource: PropTypes.string.isRequired,
  userResendLink: PropTypes.func,
  children: PropTypes.node,
  updateUI: PropTypes.func,
  ui: PropTypes.object,
  editHandler: PropTypes.node,
};

export default connectUI()(connect(null, { userResendLink })(UserDetailsHeader));



// WEBPACK FOOTER //
// ./client/app/shared/components/users/UserDetailsHeader/index.jsx